import { defineKey } from '@ha/intl';

export const KEYS = {
  tenant: {
    meta: {
      title: defineKey('pmp.online_rent_payment.meta_title'),
      description: defineKey('pmp.online_rent_payment.meta_description'),
    },
    breadcrumb: defineKey('pmp.online_rent_payment.breadcrumb'),
  },
  landlord: {
    meta: {
      title: defineKey('pmp.online_rent_collection.meta_title'),
      description: defineKey('pmp.online_rent_collection.meta_description'),
    },
    breadcrumb: defineKey('pmp.online_rent_collection.breadcrumb'),
  },
};
